<template>
  <div>
    <button class="btn btn-secondary btn-small" @click="$modal.show(modalName);">
      <i class="far fa-plus-square"></i>
      Neue Frist
    </button>
    <modal :name="modalName"
           :draggable="true"
           width="90%"
           height="auto"
           :scrollable="true"
    >
      <div class="m-4 p-4 border border-gray-500">
        <deadline-form :actionUrl="'/deadlines.json'" method="post" :initial-deadline="deadline"
                       v-on:updated="updated"/>
      </div>
    </modal>
  </div>
</template>

<script>
export default {
  props: ['deadline'],
  data() {
    return {
      modalName: 'deadline-form-modal-new',
    }
  },
  methods: {
    open: function () {
      this.$modal.show(this.modalName);
    },
    updated: function (event) {
      this.$modal.hide(this.modalName);
      this.$emit('updated');
    },
  }
}
</script>